import { Theme } from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import createSvgIcon from '@serko/zui-icons/es/utils/createSvgIcon';
import classNames from 'classnames';
import React, { createElement, PureComponent } from 'react';

interface OwnProps {
  /**
   * Number of stops
   */
  stops?: number;

  className?: string;
}

export interface ArrowProps extends OwnProps, WithStyles<typeof styles> {}

class ArrowBase extends PureComponent<ArrowProps> {
  public render() {
    const {
      classes: { root: rootClass, stopColor },
      className,
      stops = 0,
      ...props
    } = this.props;

    return createElement(
      createSvgIcon({
        viewBox: '0 0 82 24',
        path: (
          <>
            {stops === 0 && (
              // tslint:disable-next-line:max-line-length
              <path d="M65.254 13.714h-65.254v-3.429h75.497l-10.354-10.286h5.241l11.902 12.015-11.902 11.985h-5.129l10.258-10.246h-10.258z" />
            )}
            {stops === 1 && (
              <>
                {/* tslint:disable-next-line:max-line-length */}
                <path d="M65.255 13.714h-15.54v-3.429h25.783l-10.354-10.286h5.241l11.902 12.016-11.902 11.984h-5.129l10.258-10.247h-10.258v-0.039zM0 10.286h36v3.429h-36v-3.429z" />
                <path
                  className={stopColor}
                  // tslint:disable-next-line:max-line-length
                  d="M42.857 17.143c2.84 0 5.143-2.303 5.143-5.143s-2.303-5.143-5.143-5.143c-2.84 0-5.143 2.303-5.143 5.143s2.303 5.143 5.143 5.143zM42.857 20.571c-4.734 0-8.571-3.838-8.571-8.571s3.838-8.571 8.571-8.571c4.734 0 8.571 3.838 8.571 8.571s-3.838 8.571-8.571 8.571z"
                />
              </>
            )}
            {stops >= 2 && (
              <>
                {/* tslint:disable-next-line:max-line-length */}
                <path d="M65.255 13.714h-5.255v-3.429h15.497l-10.354-10.286h5.241l11.902 12.016-11.902 11.984h-5.129l10.258-10.247h-10.258z" />
                <path d="M37.714 10.286h8.571v3.429h-8.571v-3.429z" />
                <path d="M0 10.286h24v3.429h-24v-3.429z" />
                <path
                  className={stopColor}
                  // tslint:disable-next-line:max-line-length
                  d="M30.857 17.143c2.84 0 5.143-2.303 5.143-5.143s-2.303-5.143-5.143-5.143c-2.84 0-5.143 2.303-5.143 5.143s2.303 5.143 5.143 5.143zM30.857 20.571c-4.734 0-8.571-3.838-8.571-8.571s3.838-8.571 8.571-8.571c4.734 0 8.571 3.838 8.571 8.571s-3.838 8.571-8.571 8.571z"
                />
                <path
                  className={stopColor}
                  // tslint:disable-next-line:max-line-length
                  d="M53.143 17.143c2.84 0 5.143-2.303 5.143-5.143s-2.303-5.143-5.143-5.143c-2.84 0-5.143 2.303-5.143 5.143s2.303 5.143 5.143 5.143zM53.143 20.571c-4.734 0-8.571-3.838-8.571-8.571s3.838-8.571 8.571-8.571c4.734 0 8.571 3.838 8.571 8.571s-3.838 8.571-8.571 8.571z"
                />
              </>
            )}
          </>
        ),
        displayName: 'Arrow',
      }),
      { className: classNames(rootClass, className), ...props },
    );
  }
}

// styled
const styles = (theme: Theme) =>
  createStyles({
    root: {
      color: theme.zeno.icons.dark.inactive,
      height: 20,
      width: 48,
    },
    stopColor: {
      color: theme.zeno.semantic.warning.main,
      fill: theme.zeno.semantic.warning.main,
    },
  });

/**
 * Route arrow
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯⎯> // 0 stops
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯⎯⎯o⎯⎯⎯⎯⎯⎯⎯> // 1 stop
 *
 * @example
 * ⎯⎯⎯⎯⎯⎯o⎯⎯o⎯⎯⎯⎯⎯> // 2 stops
 */
export const Arrow = withStyles(styles)<OwnProps>(ArrowBase);

Arrow.displayName = 'Arrow';
